export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';
export const SHOW_TOAST_WITH_PROPS = 'SHOW_TOAST_WITH_PROPS';
export const HIDE_TOAST = 'HIDE_TOAST';
export const SESSIONCONTEXT_DATA = 'SESSIONCONTEXT_DATA';
export const HEADERCONTEXT_DATA = 'HEADERCONTEXT_DATA';